import type { ExclusionGroundsTaxonomyResponse } from "../../../../../autogen/bff-api";

export interface ExclusionGroundsSummary {
  mandatoryCount: number;
  voluntaryActiveCount: number;
  voluntaryTotalCount: number;
  disabledVoluntaryCriteria: { id: string; name: string; nameNorwegian: string | null }[];
}

const empty: ExclusionGroundsSummary = {
  mandatoryCount: 0,
  voluntaryActiveCount: 0,
  voluntaryTotalCount: 0,
  disabledVoluntaryCriteria: [],
};

export const computeExclusionGroundsSummary = (
  taxonomy: ExclusionGroundsTaxonomyResponse | undefined,
  activeIds: string[],
): ExclusionGroundsSummary => {
  if (!taxonomy) return empty;
  const activeIdSet = new Set(activeIds);
  let mandatoryCount = 0;
  let voluntaryTotalCount = 0;
  let voluntaryActiveCount = 0;
  const disabledVoluntaryCriteria: ExclusionGroundsSummary["disabledVoluntaryCriteria"] = [];
  for (const cat of taxonomy.categories) {
    for (const c of cat.criteria) {
      if (c.mandatory) {
        mandatoryCount++;
      } else {
        voluntaryTotalCount++;
        if (activeIdSet.has(c.id)) {
          voluntaryActiveCount++;
        } else {
          disabledVoluntaryCriteria.push({
            id: c.id,
            name: c.name,
            nameNorwegian: c.nameNorwegian ?? null,
          });
        }
      }
    }
  }
  return { mandatoryCount, voluntaryActiveCount, voluntaryTotalCount, disabledVoluntaryCriteria };
};
